
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class PageHeader extends Vue {
  @Prop({ default: "" }) title!: string;
  @Prop({ default: "" }) accent!: string;
  @Prop({ default: "" }) eyebrow!: string;
  @Prop({ default: "" }) subtitle!: string;
}
